import React from 'react';
import { FormationsType } from 'types/formation/formations.def';
import { PedagogiesType } from 'types/pedagogies/pedagogies.def';
import { RessourcesTypeButton } from 'components/atoms/Buttons/RessourcesTypeButton';
import useStyle from './ressourcesTypeContainer.style';
import { BackButton } from 'components/molecules/Buttons/BackButton';

interface RessourcesTypeContainerProps {
  ressourcesType: FormationsType[] | PedagogiesType[];
  variant: 'red' | 'blue' | 'orange';
}

export const RessourcesTypeContainer = ({
  ressourcesType,
  variant
}: RessourcesTypeContainerProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <BackButton text="Retour aux catégories" />
      <p className={classes.title}>Choisir un thème :</p>
      {ressourcesType.map((type, index) => (
        <RessourcesTypeButton
          key={index}
          ressourcesType={type}
          variant={variant}
        />
      ))}
    </div>
  );
};
